import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { FaceDetectionResponse } from '../responses/face-detection.response';
import { FaceDetectionRequest } from '../requests/face-detection.request';
import { GetSnapshotResponse } from '../responses/get-snapshot.response';

@Injectable({
  providedIn: 'root',
})
export class FaceDetectionService {
  private readonly http = inject(HttpClient);

  compareFace(
    participantId: string,
    licenseImageBytes: string,
  ): Observable<FaceDetectionResponse> {
    const request: FaceDetectionRequest = {
      participantId,
      snapshotBase64Image: licenseImageBytes,
    };
    return this.http.post<FaceDetectionResponse>(
      `/api/participants/${participantId}/id-verification/face-comparison`,
      request,
    );
  }

  getUserSnapshot(participantId: string): Observable<GetSnapshotResponse> {
    return this.http.get<GetSnapshotResponse>(
      `/api/participants/${participantId}/id-verification/user-snapshot`,
    );
  }
}
